import { KeyRound } from 'lucide-react';

// Incremental consent: Google shows only what's new (Gmail read, Contacts read) and keeps what was already granted.
export function AuthorizeGoogle({ back, label = 'Authorize Gmail & Contacts access' }: { back: string; label?: string }) {
  return <a className="btn primary sm" href={`/auth/workspace/connect?return=${encodeURIComponent(back)}`}><KeyRound size={13} aria-hidden /> {label}</a>;
}
